import * as React from 'react';

import { Grid,  Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import ResponsiveImgMaterialUi from "responsive-img-material-ui";

import zdjecie from './../../zdjecia/zjedz.png'
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import OknoMapa from '../wypozycz/OknoMapa';
import SearchIcon from '@material-ui/icons/Search';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import DialogLink from 'components/DialogLink';
import { sendErrorLog } from 'common/helpers';



interface DoladujKarnetProps {
  page: IPageState,
  setPanel: (p: number, s: number) => void,
}

interface DoladujKarnetState {
  openMapa: boolean,
  openLink: boolean,
  openInfo: boolean,
}



class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      openMapa: false,
      openLink: false,
      openInfo: false,
    }
  }

  componentDidMount() {
    sendErrorLog("1", "1", 'zjedz')
  }

  openRegulamin = () => {
    if(this.props.page.regulaminZamowienia){
      window.open("https://vsc24.net/vscKelnerBook/hotel/kelner-TEST", "_blanc")
    } else {
      this.props.setPanel(2, 1)
    }   
  }

  openGastronomia = () => {
    if(CONFIG.karnetZjedzLink === "1"){
      this.openInfo()
    } else {
      this.openLink()
    }
  }

  openMapa = () => {
    this.setState({openMapa: true})
  }
  closeMapa = () => {
    this.setState({openMapa: false})
  }
  openLink = () => {
    this.setState({openLink: true})
  }
  closeLink = () => {
    this.setState({openLink: false})
  }
  openInfo = () => {
    this.setState({openInfo: true})
  }
  closeInfo = () => {
    this.setState({openInfo: false})
  }


  
  render() {
    const { classes, t } = this.props;
    let primary = theme.palette.primary.main

    let disabled = !this.props.page.jestKarnet
    
      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} >
                
                  {/* <div style={{
                      textAlign: 'center',
                  }}>

                      <ResponsiveImgMaterialUi style={{ width: "85%", maxWidth: "330px" }}
                          xs={zdjecie}
                      />
                  </div> */}

                  <div style={{width: "fit-content", margin: "auto"}}>
                    <Typography variant="h6" component="h2" onClick={() => this.openMapa()} color='textSecondary' className={classes.text} style={{cursor: "pointer"}}>
                      <SearchIcon className={classes.icon} style={{ fontSize: "28px", marginRight: "6px" }} />
                      <Link target='_blank' underline="hover" className={classes.color} style={{ }}>{'zobacz gdzie punkty gastro'}</Link>
                      {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                    </Typography>
                    <Typography variant="h6" component="h2" onClick={() =>  this.openGastronomia() } color='textSecondary' className={classes.text} style={{cursor: "pointer"}}>
                      {/* onClick={() => !disabled ? this.openRegulamin() : store.dispatch(Actions.pageState.setOpenInfo()) } */}
                      <LocalDiningIcon className={classes.icon} />
                      {/* href="https://vsc24.net/vscHotelBook/hotel/lesko-SKI" */}
                      <Link target='_blank' underline="hover" className={classes.color}>{'zamów'}</Link>
                      {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                    </Typography>
                  </div>    

                  

                  <DialogLink open={this.state.openInfo} close={this.closeInfo} title="gastronomia" text="wkrótce otwarcie" />
                  <DialogLink open={this.state.openLink} close={this.closeLink} title="gastronomia" text="funkcja chwilowo wyłączona" />

                  <OknoMapa open={this.state.openMapa} closeDialog={this.closeMapa} zdjecie={zdjecie} tytul={"gastronomia"}/>
              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
  container1: {
    //margin: "0em",
    //paddingTop: "0.4em",
    margin: "30px auto 0px",
    padding: '0em 0em',
    minHeight: "100%",
    maxWidth: "1340px",
    //border: "2px solid lavender"
  },
  gridItem: {
    minHeight: "150px",
  },
  item: {
    height: "40px",
    textAlign: "center" as "center",
    border: "1px solid lavender",
    marginBottom: "4px",
    backgroundColor: "#FCFCFC", //"#F5F5F5",
    paddingLeft: "0",
    paddingRight: "0",
    "&:hover": {
      backgroundColor: "#F1F1F1", //"#EEE"
    },
  },
  itemText: {
    color: "rgb(255, 165, 0)",
    fontSize: "14px"//"2.5rem"
  },
  color: {
    color: "lightseagreen",
    cursor: "pointer"
  },
  text: {
    color: theme.palette.text.secondary,
    whiteSpace: "pre" as "pre",
    minHeight: "12px",
    marginTop: '12px',
    marginBottom: '12px',
    fontSize: "16px",

    display: "flex" as "flex",
    justyfyContent: "center",
    alignItems: "center"
  },
  icon: {
    fontSize: "30px", 
    color: "rgb(255, 165, 0)", 
    marginRight: "10px"
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

